/**
 * @ngdoc Directive
 * @name vrmVeconfigureWidget
 * @example
 *
 * <vrmVeconfigureWidget installation="installation" />
 *
 */
import { handleFileDownload } from "@/utils/download";

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmVeconfigureWidget', vrmVeconfigureWidget);

    /* @ngInject */
    function vrmVeconfigureWidget() {

        return {
            restrict: 'E',
            template: require('@/angular/modules/vrm-components/veconfigure-widget/veconfigure-widget.template.html'),
            controller: controller,
            scope: {
                iconClass: '=',
                customName: '=',
                installation: '=',
                range: '=',
                isMobile: '=',
                hasTouchEnabled: '=',
                size: '='
            }
        };

        /* @ngInject */
        function controller($scope, locale, ApiService, vrmNotificationsService, vrmNotificationType) {
            $scope.$watch('installation', function(installation) {
                if (installation != null) {
                    ApiService.installations(installation.id, 've-configure-list').then(function(response) {
                        $scope.files = response.data.data;
                    });
                }
            });

            $scope.$watch('size', () => {
                if (!$scope.chart || !$scope.chart.getHighcharts) return;
                $scope.chart.getHighcharts().reflow();
            });

            $scope.download = function(file) {
                $scope.selected = null;
                ApiService.download(file.url, null).then(function(response) {
                    handleFileDownload(response.data, file.name);
                });
            };

            $scope.replace = function(files) {
                if (files[0]) {
                    var file = files[0];
                    var data = new FormData();
                    var currentFile = $scope.selected;
                    $scope.selected = null;
                    data.append('data', file);
                    data.append('filename', currentFile.name);
                    ApiService.installations($scope.installation.id, 've-configure-upload', data, 'POST').then(function() {
                        vrmNotificationsService.add( {type: vrmNotificationType.SUCCESS, message: locale.getString('advanced.ve_uploaded') });
                        currentFile.timestamp = Date.now() / 1000;
                    });
                }
            };

            $scope.select = function(file) {
                $scope.selected = file;
            };

            $scope.close = function() {
                $scope.selected = null;
            }
        }
    }
})();
